import { render, staticRenderFns } from "./TermosUso.vue?vue&type=template&id=1c42c0dc&scoped=true"
import script from "./TermosUso.vue?vue&type=script&lang=js"
export * from "./TermosUso.vue?vue&type=script&lang=js"
import style0 from "./TermosUso.vue?vue&type=style&index=0&id=1c42c0dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42c0dc",
  null
  
)

export default component.exports